import type { Feedback } from '../../types/feedback.js';

/**
 * 投稿者の「既読位置」を localStorage に保存する際のキー。
 * 値は最後に既読化したスレッドの lastMessageAt の epoch(ms) 文字列。
 */
export function readStorageKey(feedbackId: string): string {
  return `feedback-read-${feedbackId}`;
}

/** isFeedbackUnread / countUnread が必要とする最小フィールド */
type UnreadFields = Pick<Feedback, 'lastMessageRole' | 'lastMessageAt'>;

/**
 * 投稿者にとって未読かどうか。
 *
 * 最新メッセージが管理者（admin）発言で、かつ保存済みの既読 epoch よりも新しい場合に未読。
 * 既読記録が無い（seenEpoch == null）場合は、管理者発言があれば未読扱いとする。
 *
 * 既読位置はクライアント（localStorage）にのみ持つため、複数端末では同期しない。
 */
export function isFeedbackUnread(
  fb: UnreadFields,
  seenEpoch: number | null | undefined,
): boolean {
  if (fb.lastMessageRole !== 'admin' || !fb.lastMessageAt) return false;
  const last = fb.lastMessageAt.getTime();
  return seenEpoch == null || last > seenEpoch;
}

/**
 * 未読件数を数える。getSeen は feedbackId から既読 epoch(ms)（無ければ null）を返す関数。
 */
export function countUnread(
  feedbacks: ReadonlyArray<UnreadFields & Pick<Feedback, 'id'>>,
  getSeen: (id: string) => number | null | undefined,
): number {
  return feedbacks.filter((fb) => isFeedbackUnread(fb, getSeen(fb.id))).length;
}
